<app-nav></app-nav>
<section class="login-section set-profile">
  <div class="container">
    <div class="mx-auto" style="display: flex;justify-content:center">
      <span style="width:75%;" id="snackbar"></span>
    </div>
    <div *ngIf="!this.routeParam" class="view-profile">
      <div class="profile-heading">
        <h5>Your Profile</h5>
        <div class="profile-edit-icon" routerLink="/edit-profile">
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/edit.svg" />
        </div>
      </div>
      <div class="row">
        <div class="col-6 view-col">
          <p>Name</p>
          <p>{{profileData.name ? profileData.name : ('--')}}</p>
        </div>
        <div class="col-6 view-col">
          <p>Mobile No.</p>
          <p>{{profileData.mobile ? profileData.mobile : ('--')}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6 view-col">
          <p>Date of Birth</p>
          <p>{{profileData.dob ? (profileData.dob | date: 'dd/M/yyyy') : ('--')}}</p>
        </div>
        <div class="col-6 view-col">
          <p>Company</p>
          <p>{{profileData.company ? profileData.company : ('--')}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 view-col">
          <p>Email Address</p>
          <p>{{profileData.email ? profileData.email : ('--')}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="this.routeParam==='add-family'" class="view-profile">
      <div class="row">
        <h5 class="text-dark mt-2 ml-4">Family Details</h5>
        <button *ngIf="hasCard" class="border-btn mx-3" (click)="addFamilyMemberFields()">Add More</button>
      </div>
      <p class="text-danger text-left ml-2 mt-1" style="font-size: 14.5px;"><strong>Disclaimer</strong> : After Submission it will take 15 to 20 days for the dependents eCards to reflect on the app. For any queries, please contact help@securenow.in.</p>

      <ng-container *ngIf="profileData.family && viewFamilyDetails">
        <div class="row mt-3 addNewModals">
          <div style="display: flex" class="mb-4 col-md-5 col-12" *ngFor="let member of profileData.family ;let i=index">
            <div class="memberCard pt-3 px-3 mx-1" style="display: flex" >
            <div *ngIf="member._id" style="display: flex; flex-direction: column;">
              <div >
                <div class="row mt-2">
                  <div class="col-12">
                    <p class="labelForCard" style="color: #120e3c;"> Member Name</p>
                    <p>{{member.name}}</p>
                  </div>
                 
                </div>
                <div class="row mt-5">
                  <div class="col-6 view-col">
                    <p class="labelForCard" style="color: #120e3c;">Relation</p>
                    <p>{{member.relationship}}</p>
                  </div>
                  <div class="col-6 view-col">
                    <p class="labelForCard" style="color: #120e3c;">Date of Birth</p>
                    <p>{{member.dob | date: 'dd/M/yyyy'}}</p>
                  </div>
                </div>   
                <div class="row mt-2">
                  <div class="col-6 view-col">
                    <p class="labelForCard" style="color: #120e3c;"> Gender</p>
                    <p>{{member.gender}}</p>
                  </div>
                  <div class="col-6 view-col" *ngIf="member.dateOfMarriage">
                    <p class="labelForCard" style="color: #120e3c;">Date of Marriage</p>
                    <p>{{member.dateOfMarriage | date: 'dd/M/yyyy'}}</p>
                  </div>
                </div>
              </div>   
            <div class="row" style="flex: 1; align-content: end;">
              <img src="../../assets/images/Group 1081.svg" style="height: fit-content; width: 100%;" />
            </div>
            </div>
            <div *ngIf="!member._id" class="pt-1">
          <form #addFamilyForm="ngForm" (ngSubmit)="addFamilyMembers(addFamilyForm)">
                <div class="row">
                  <div class="form-group col-12">
                    <label class="labelForCard" style="color: #120e3c;">Member Name</label>
                    <input type="text" class="form-control" maxlength="200" #name="ngModel" pattern="^[^\s]+[-a-zA-Z\s]+([-a-zA-Z]+)*$"
                      name="name{{i}}" [(ngModel)]="member.name" required [disabled]="!this.hasCard"/>
                    <div *ngIf="name.invalid && name.touched " class="error-message">
                      <div *ngIf="name.errors.pattern">
                        Please enter valid name.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label class="labelForCard" style="color: #120e3c;">Date of Birth</label>
                    <div class="input-group addon datepicker">
                      <p-calendar class="dob-calendar" [maxDate]="familyMaxDate" [touchUI]="true" [readonlyInput]="true"
                        name="dob{{i}}" id="dob" #dob="ngModel" placeholder="Date" [(ngModel)]="member.dob"
                        value="{{familyData.dob}}" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="1930:{{familyMaxDate.getFullYear()}}" [disabled]="!this.hasCard" required>
                      </p-calendar>
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="labelForCard" style="color: #120e3c;">Relation</label>
                    <select class="form-control" name="relation{{i}}" [(ngModel)]="member.relationship" [disabled]="!this.hasCard" required>
                      <option value="">Select</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Father') === -1">Father</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Mother') === -1">Mother</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Father In Law') === -1">Father In Law</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Mother In Law') === -1">Mother In Law</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Husband') === -1">Husband</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Wife') === -1">Wife</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Son') === -1">Son</option>
                      <option *ngIf="addedFamilyRelation.indexOf('Daughter') === -1">Daughter</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label class="labelForCard" style="color: #120e3c;">Gender</label>
                    <select class="form-control" name="gender{{i}}" [(ngModel)]="member.gender" [disabled]="!this.hasCard" required>
                      <option value="">Select</option>
                      <option>Male</option>
                      <option>Female</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div class="form-group col-6" *ngIf="member.relationship === 'Husband' || member.relationship === 'Wife'">
                    <label class="labelForCard" style="color: #120e3c;">Date of Marriage</label>
                    <div class="input-group addon datepicker">
                      <p-calendar class="dob-calendar" [maxDate]="familyMaxDate" [touchUI]="true" [readonlyInput]="true"
                        name="dateOfMarriage{{i}}" id="dateOfMarriage{{i}}" #dateOfMarriage="ngModel" placeholder="Date"
                        [(ngModel)]="member.dateOfMarriage" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="1950:{{familyMaxDate.getFullYear()}}" [disabled]="!this.hasCard" required>
                      </p-calendar>
                    </div>
                  </div>
                </div>
                <div class="buttonCards">
                <button type="submit" (ngSubmit)="addFamilyMembers(addFamilyForm)" class="border-btn" [disabled]="!this.hasCard">Save</button>
              </div>
                <img src="../../assets/images/Group 1081.svg" style="height: fit-content; width: 100%;" />
              </form>

            </div>
          </div>
        </div>
        </div>
     
      </ng-container>
    </div>
  </div>
 
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>